if (!customElements.get('careiz-cart-controller')) {
  customElements.define('careiz-cart-controller',class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.owner = this.dataset.sectionId;
      this.template = this.querySelector('[data-careiz-cart-template]');
      this.message = '';
      this.mount = this.mount.bind(this);
      this.feedback = event => {
        this.message = event.detail.message;
        this.instances().forEach(element => {
          const status = element.querySelector('[data-careiz-status]');
          if (status) status.textContent = this.message;
        });
      };
      this.select = event => {
        if (event.detail.sectionId === this.owner && !document.querySelector('[data-careiz-cart-slot="page"]')) document.querySelector('cart-drawer')?.open();
      };
      document.addEventListener('careiz:cart-offer-feedback',this.feedback);
      document.addEventListener('shopify:section:select',this.select);
      this.observer = new MutationObserver(() => {
        if (this.pending) return;
        this.pending = true;
        queueMicrotask(() => {this.pending = false;if (this.isConnected) this.mount();});
      });
      this.observer.observe(document.body,{childList:true,subtree:true});
      this.mount();
    }
    instances() { return [...document.querySelectorAll('careiz-upsells[data-cart-owner]')].filter(element => element.dataset.cartOwner === this.owner); }
    mount() {
      if (!this.template) return;
      for (const slot of document.querySelectorAll('[data-careiz-cart-slot]')) {
        const enabled = slot.dataset.careizCartSlot === 'page' ? this.dataset.showPage === 'true' : this.dataset.showDrawer === 'true';
        const current = slot.querySelector('careiz-upsells[data-cart-owner]');
        if (!enabled) {if (current?.dataset.cartOwner === this.owner) current.remove();continue;}
        if (current?.dataset.cartOwner === this.owner) continue;
        const element = this.template.content.querySelector('careiz-upsells')?.cloneNode(true);
        if (!element) continue;
        element.dataset.cartOwner = this.owner;
        const status = element.querySelector('[data-careiz-status]');
        if (status) status.textContent = this.message;
        slot.replaceChildren(element);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('careiz:cart-offer-feedback',this.feedback);
      document.removeEventListener('shopify:section:select',this.select);
      this.instances().forEach(element=>element.remove());
    }
  });
}
